import React from "react";

export const GS_EMOJIS = Array.from({ length: 20 }, (_, i) => `:gs${i + 1}:`);
const RE = /(:gs(?:[1-9]|1\d|20):)/g;
const src = (tok) => `/emoji/e${tok.slice(3, -1)}.webp?v=2`;

export const isOnlyEmoji = (body) => !!body && body.replace(RE, "").trim() === "";

export function EmojiText({ body, big }) {
  if (!body) return null;
  return body.split(RE).map((part, i) =>
    /^:gs\d+:$/.test(part)
      ? <img key={i} src={src(part)} alt="" draggable={false} className={`inline-block align-middle ${big ? "w-24 h-24" : "w-7 h-7"}`} />
      : <React.Fragment key={i}>{part}</React.Fragment>
  );
}

export const emojiPreview = (body) => (body || "").replace(RE, "🙂");
